import { EVENT_REDIRECTION_URL } from 'utils/constants';

export const GUEST_LOGIN_STEPS = [
    'Tap "Guest Login"',
    'Tap "Create your password"',
    'Enter your registered email to receive your password link',
];

export const DOWNLOAD_APP_HEADINGS = {
    DOWNLOAD: 'Download Our App',
    CONTINUE_ON_APP: 'Continue On App',
};

export const GUEST_LOGIN_SUBHEADING = 'After downloading the app:';

export const DEFAULT_QR_CODE_SIZE = '250px';

export const CONTINUE_BUTTON_LABELS = {
    BROWSER: 'Continue in Browser',
    WEB: 'Continue on Web',
};

/** Same QR target as /download-app when opened without a url query param. */
export const getDownloadAppPageQrUrl = () =>
    `${window.location.origin}/${EVENT_REDIRECTION_URL}`;
